import { render, staticRenderFns } from "./reportExamine.vue?vue&type=template&id=24209099&scoped=true"
import script from "./reportExamine.vue?vue&type=script&lang=ts"
export * from "./reportExamine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24209099",
  null
  
)

export default component.exports